import React from 'react';
import {
  STATES,
  districtsForState,
  mandalsForDistrict,
  makeCityCode,
} from '../data/indiaLocations';

/**
 * State → District → Mandal/Town (select only — updated AP 28 / TG 33 boundaries).
 * GPS map pin sets street/area separately (locality field).
 */
export default function LocationCascadeSelect({
  state,
  district,
  city,
  mandal,
  locality,
  onChange,
  disabled = false,
}) {
  const selectedMandal = mandal || city || '';
  const districts = state ? districtsForState(state) : [];
  const mandals = state && district ? mandalsForDistrict(state, district) : [];

  const emit = (next) => {
    const s = next.state ?? state ?? '';
    const d = next.district ?? district ?? '';
    const m = next.mandal ?? next.city ?? selectedMandal ?? '';
    onChange({
      state: s,
      district: d,
      city: m,
      mandal: m,
      locality: next.locality ?? locality ?? '',
      cityCode: s && m ? makeCityCode(s, d, m) : '',
    });
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14 }}>
        <div className="form-group">
          <label className="form-label">State *</label>
          <select
            className="form-input"
            value={state || ''}
            disabled={disabled}
            onChange={(e) => emit({ state: e.target.value, district: '', mandal: '', city: '' })}
          >
            <option value="">Select state</option>
            {STATES.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">District *</label>
          <select
            className="form-input"
            value={district || ''}
            disabled={disabled || !state}
            onChange={(e) => emit({ district: e.target.value, mandal: '', city: '' })}
          >
            <option value="">{state ? 'Select district' : 'Select state first'}</option>
            {districts.map((d) => (
              <option key={d} value={d}>{d}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Mandal / Town *</label>
          <select
            className="form-input"
            value={selectedMandal}
            disabled={disabled || !state || !district}
            onChange={(e) => emit({ mandal: e.target.value, city: e.target.value })}
          >
            <option value="">{district ? 'Select mandal or town' : 'Select district first'}</option>
            {mandals.map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
      </div>

      {locality ? (
        <div className="form-group" style={{ marginTop: 8 }}>
          <label className="form-label">Area / Street (from map pin)</label>
          <input type="text" className="form-input" value={locality} readOnly style={{ opacity: 0.85 }} />
        </div>
      ) : null}

      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>
        Updated admin map (2026): Tirupati is a separate district · AP has 28 districts · Telangana has 33
      </div>
    </div>
  );
}
